import { Component, OnInit } from '@angular/core';
import { PaymentSettingsService } from 'app/@core/backend/common/services/CalorieFriend/payment-settings.service';
import { StripeAccount } from 'app/@core/interfaces/common/stripe';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit {

  currentAccount: Observable<StripeAccount>;
  isLoading: boolean = false;

  constructor(private paymentSettingsService: PaymentSettingsService) { }

  ngOnInit() {
    this.paymentSettingsService.isLoading.subscribe((status: boolean): void =>{
      this.isLoading = status;
    });
    this.currentAccount = this.paymentSettingsService.currentAccount;
  }

}
